import React from 'react';
import CreateReactClass from 'create-react-class';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';

import DropdownMenu from 'components/generic/controls/dropdown-menu';
import Getters from 'data/getters';
import Actions from 'data/actions';
import Reactor from 'data/reactor';

import Analytics from 'utils/analytics';
import popover from 'utils/popover';
import { findShowMethodForModal } from 'utils/runtime';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'term-dropdown',

    propTypes: {
        studentBid: PropTypes.string,
        termsWithTestEvents: PropTypes.instanceOf(Immutable.List),
        selectedTermNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        unsavedData: PropTypes.bool,
    },

    changeTerm(termNumber) {
        popover.closeChartPopoverBoxes();
        const mainElement = document.getElementById('report-content');
        Analytics.recordButtonClick('student-info', 'change-term-dropdown');
        mainElement.className = mainElement.className.replace('term-changed', ''); // remove any existing term-change styling
        mainElement.className = mainElement.className.replace('term-changing', '') + ' term-changing'; // ensure that the fade-out transitions are set

        setTimeout(() => {
            document.getElementById('termSelection').value = termNumber;
        }, 1);

        Actions.student.changeSelectedTermNumber(this.props.studentBid, parseInt(termNumber), false, true);
        setTimeout(() => {
            // after the fade-out, set the fade-in transitions
            mainElement.className = mainElement.className.replace('term-changing', '') + ' term-changed';
        }, 750);
        setTimeout(() => {
            // after the fade-in, remove the transition setting.
            mainElement.className = mainElement.className.replace('term-changed', '');
        }, 1500);
    },

    triggerChangeTerm(termNumber) {
        if (this.props.unsavedData) {
            const globalModalReferences = Reactor.evaluate(Getters.runtime.modalReferences);
            const showSaveDataPrompt = findShowMethodForModal(
                globalModalReferences,
                CommonValues.sharedModalReferences.saveDataPrompt
            );
            showSaveDataPrompt()
                .then(() => {
                    this.changeTerm(termNumber);
                    Actions.runtime.setUnsavedData(false);
                })
                .catch(() => {
                    /* do nothing */
                });
        } else {
            this.changeTerm(termNumber);
        }
    },

    render() {
        return (
            <DropdownMenu
                id="termSelection"
                label="Term: "
                onChange={this.triggerChangeTerm}
                optionList={this.props.termsWithTestEvents}
                selectedOptionValue={this.props.selectedTermNumber}
                elementValueFunction={(term) => term.get('termNumber')}
                elementDisplayFunction={(term) => term.get('name')}
                classesDivWrapper="dropdown"
            />
        );
    },
});
